module.exports = __webpack_public_path__ + "fonts/PrestigeEliteStd-Bd.8998e69e.woff";